module.exports = __webpack_public_path__ + "static/media/swift.3f36cb02.svg";